import { environmentConfig } from '../config/environment';

class ApiClient {
    private brandId: string | null = null;
    private baseUrl: string;

    constructor() {
        // Use validationApi as base, stripping /validation if present to get /api/v1
        this.baseUrl = environmentConfig.api.validationApi.replace('/validation', '') || 'https://api.fashcortex.com/api/v1';
    }

    /**
     * Set the brand ID for all subsequent requests
     */
    public setBrandId(brandId: string | null): void {
        this.brandId = brandId;
    }

    /**
     * Generic POST request
     */
    public async post<T>(url: string, data: any): Promise<{ data: T }> {
        const response = await fetch(`${this.baseUrl}${url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(this.brandId ? { 'x-brand-id': this.brandId } : {})
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Request failed with status ${response.status}`);
        }

        const result = await response.json();
        return { data: result.data || result };
    }

    /**
     * Generic GET request
     */
    public async get<T>(url: string): Promise<{ data: T }> {
        const response = await fetch(`${this.baseUrl}${url}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(this.brandId ? { 'x-brand-id': this.brandId } : {})
            }
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Request failed with status ${response.status}`);
        }

        const result = await response.json();
        return { data: result.data || result };
    }
}

const apiClient = new ApiClient();
export default apiClient;
